export default "__VITE_ASSET__VWZ4wkSc__"